module.exports = __webpack_public_path__ + "static/media/image4.973d55a8.PNG";